"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersion5toVersion6 = void 0;
const common_1 = require("../common");
const getDeltaFromTextConfiguration = (textConfiguration, size) => {
    const { text, font, color } = textConfiguration;
    if (text === "") {
        return { ops: [{ insert: "\n", attributes: { align: "center" } }] };
    }
    if (text.includes("\n")) {
        const textArray = text.split("\n");
        return { ops: textArray.flatMap((text) => [
                { insert: text, attributes: { size: size, font: (0, common_1.getFontNameForClass)(font), color } },
                { insert: "\n", attributes: { align: "center" } }
            ])
        };
    }
    return { ops: [
            { insert: text, attributes: { size: size, font: (0, common_1.getFontNameForClass)(font), color } },
            { insert: "\n", attributes: { align: "center" } }
        ] };
};
const updateVersion5toVersion6 = (configuration) => {
    return Object.assign(Object.assign({}, configuration), { version: 6, main: Object.assign(Object.assign({}, configuration.main), { headline: {
                delta: getDeltaFromTextConfiguration(configuration.main.headline, "54px")
            }, subheadline: {
                delta: getDeltaFromTextConfiguration(configuration.main.subheadline, "28px")
            }, buttons: configuration.main.buttons.map(button => {
                return Object.assign(Object.assign({}, button), { text: {
                        delta: getDeltaFromTextConfiguration(button.text, "18px")
                    } });
            }) }), footer: Object.assign(Object.assign({}, configuration.footer), { disclaimer: {
                delta: getDeltaFromTextConfiguration(configuration.footer.disclaimer, "14px")
            }, privacyPolicy: Object.assign(Object.assign({}, configuration.footer.privacyPolicy), { font: `${configuration.footer.disclaimer.font}` }) }) });
};
exports.updateVersion5toVersion6 = updateVersion5toVersion6;
//# sourceMappingURL=v6.js.map